import AddEmployee from "./add-employee";

export default AddEmployee;